// DS: MO3.4.2
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviationShopCard, {
  type DeviationShopCardProps,
} from '../DeviationShopCard';
import { formatDollars } from '../../utils/formatting';

import s from './OriginalsShopCard.scss';

export interface Props
  extends Pick<DeviationShopCardProps, 'allowedIndicators'> {
  deviation: PapiDeviation;
  width: number;
  withAuthorDetails?: boolean;
  withDescriptionBlock?: boolean;
}

const OriginalsShopCard: React.FC<Props> = ({
  width,
  deviation,
  withAuthorDetails,
  allowedIndicators,
  withDescriptionBlock = false,
}) => {
  const { t } = useTranslation();
  const originals = deviation.originals || deviation.extended?.originals;
  const completedOrdersCount = originals?.completedOrdersCount ?? 0;

  const belowCoverImageRightSlot =
    originals &&
    (completedOrdersCount === 0 ? (
      <div className={s['orders-count']}>
        {t('shop.thumb.originals.makeFirstOrder')}
      </div>
    ) : (
      <div className={s['orders-count']}>
        {t('shop.thumb.originals.totalOrders', {
          count: completedOrdersCount,
        })}
      </div>
    ));

  const detailsRightSlot = originals && (
    <Flex direction="column" className={s['details']}>
      <div className={s['base-price']}>
        <div className={s['base-price-dollars']}>
          {formatDollars(originals.basePrice)}
        </div>
        {t('shop.thumb.originals.basePrice')}
      </div>
    </Flex>
  );

  return (
    <DeviationShopCard
      width={width}
      deviation={deviation}
      withStats={true}
      withDescriptionBlock={withDescriptionBlock}
      withAuthorDetails={withAuthorDetails}
      allowedIndicators={allowedIndicators}
      belowCoverImageRightSlot={belowCoverImageRightSlot}
      detailsRightSlot={detailsRightSlot}
    />
  );
};
OriginalsShopCard.displayName = 'OriginalsShopCard';

export default OriginalsShopCard;
